module.exports = "/site/themes/rkt/_/buckleys/node_modules/@fortawesome/fontawesome-pro/webfonts/fa-brands-400.eot";


//////////////////
// WEBPACK FOOTER
// ../~/@fortawesome/fontawesome-pro/webfonts/fa-brands-400.eot
// module id = 59
// module chunks = 3